import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { signOut } from 'aws-amplify/auth';
import { useUser } from "../../../UserContext";
import { ProfileIcon, BellIcon, MenuIcon } from '../../../Constants/Icons';

const Navbar = () => {
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    const { isSignedIn, setIsSignedIn } = useUser();

    // Redirect to signin page 
    const handleLogin = () => {
        navigate("/admins/login");
    };

    const handleSignOut = async () => {
        try {
            await signOut();
            navigate('/admins');
            setIsSignedIn(false)
        } catch (error) {
        }
    };

    // Logo redirects to homepage 
    const handleLogo = () => {
        navigate("/admins");
    };

    const handleDashboard = () => {
        navigate("/admins/profile/dashboard");
    };


    const handleSignup = () => {
        navigate("/admins/signup");
    }

    const handleProfile = () => {
        navigate("/admins/profile/");
    }

    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const handleClickOutside = (event) => {
        // Check if the click is outside the dropdown or the sign out button
        if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.closest('.sign-out-button')) {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        if (isVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isVisible]);


    const [isMenuVisible, setIsMenuVisible] = useState(false);

    const toggleMenuVisibility = () => {
        setIsMenuVisible(!isMenuVisible);
    };

    return (
        <div className="w-full h-[60px] flex flex-row justify-between items-center px-basePx xs:px-xsPx 1.5xl:py-[18px] 1.5xl:px-[104px] bg-[#26051C] z-50">
            <button className="" onClick={handleLogo}>
                <img
                    src={'https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/charmhealthhub_logo_wht_ylw.png'}
                    alt="Logo"
                    className="w-[248px] min-w-[248px] xl:w-[280px]"
                />
            </button>
            {
                isSignedIn ?
                    <div>
                        <button className="lg:hidden" onClick={toggleMenuVisibility}>
                            <MenuIcon />
                        </button>

                        {isMenuVisible && (
                            <div className="lg:hidden px-[32px] fixed top-0 right-0 bg-[#26051C] flex flex-col w-full h-screen" style={{ zIndex: 50 }}>
                                <button className="pr-[12px] pt-[12px]  text-white self-end  text-[20px] font-extrabold" onClick={toggleMenuVisibility}>
                                    X
                                </button>

                                <div className="mt-[20px] w-full flex flex-col items-center gap-[12px] ">
                                    <button className="h-fit w-fit text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleDashboard}>
                                        Dashboard
                                    </button>
                                    <button className="h-fit w-fit text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={toggleVisibility}>
                                        My Info
                                    </button>
                                </div>

                                {isVisible && (
                                    <div ref={dropdownRef} className="fixed top-0 right-0 bg-white border border-gray-300 p-4 flex flex-col w-[25rem] h-40 z-50">
                                        <a href="https://ehr2.charmtracker.com/ehr/physician/accountSettings.do?method=viewMyProfile" className="text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full mr-5">
                                            My Account
                                        </a>
                                        <div className="mt-6 flex flex-row justify-end">
                                            <button className="sign-out-button text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full " onClick={handleSignOut}>Sign Out</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="hidden lg:flex flex-row mx-4 xs:mx-6 gap-4 xs:gap-12 justify-between items-center">
                            <button className="h-full text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleDashboard}>
                                Dashboard
                            </button>
                            <button onClick={toggleVisibility}>
                                <ProfileIcon />
                            </button>
                        </div>

                        {isVisible && (
                            <div ref={dropdownRef} className="fixed top-0 right-0 bg-white border border-gray-300 p-4 flex flex-col w-[25rem] h-40 z-50">
                                <div className="mt-6 flex flex-row justify-end">
                                    <button className="text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full " onClick={handleSignOut} >Sign Out</button>
                                </div>
                            </div>
                        )}
                    </div>
                    :
                    <div className="">
                        <button className="lg:hidden" onClick={toggleMenuVisibility}>
                            <MenuIcon />
                        </button>

                        {isMenuVisible && (
                            <div className="lg:hidden px-[32px] fixed top-0 right-0 bg-[#26051C] flex flex-col w-full h-screen" style={{ zIndex: 50 }}>
                                <button className="pr-[12px] pt-[12px]  text-white self-end  text-[20px] font-extrabold" onClick={toggleMenuVisibility}>
                                    X
                                </button>

                                <div className="mt-[20px] w-full flex flex-col items-center gap-[12px]">
                                    <button className="h-fit w-fit text-white text-[18px] font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleLogin}>
                                        Login
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="hidden lg:flex flex-row mx-4 xs:mx-6 gap-4 xs:gap-12 justify-between items-center">
                            <button className="h-full text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={handleLogin}>
                                Login
                            </button>
                        </div>
                    </div>
            }


        </div>
    );
}

export default Navbar;